<template>
    <div class="order-stylesheet">
        <PaginatedResource :fetch-method="fetchOrderStylesheet" :sorting-fields="sortingFields">
            <template #default="{ loading, resource, isEmpty, canLoadMore, loadMore, sort }">
                <div class="order-stylesheet__paginated">
                    <Spinner v-if="loading" />
                    <StylesheetResults
                        :items="resource"
                        :loading="loading"
                        :is-empty="isEmpty"
                        :sort-by="sortingFields"
                        read-only
                        @sort="sort"
                    />

                    <div v-if="canLoadMore" class="order-stylesheet__loadmore">
                        <button
                            v-t="'misc.loadmore'"
                            class="button button--big button--blank"
                            type="button"
                            @click="loadMore"
                        />
                    </div>
                </div>
            </template>
        </PaginatedResource>
    </div>
</template>

<script>
import { fetchOrderStylesheet } from '../../api/stylesheet';
import Spinner from '@speechki-frontend/shared/ui/Spinner';
import PaginatedResource from '@speechki-frontend/shared/PaginatedResource';
import { StylesheetResults } from '@/stylesheet/components';

export default {
    name: 'OrderStylesheet',
    components: {
        Spinner,
        PaginatedResource,
        StylesheetResults,
    },
    props: {
        orderId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            sortingFields: ['id', 'target', 'explanation'],
        };
    },
    methods: {
        fetchOrderStylesheet(params) {
            return fetchOrderStylesheet(this.orderId, params);
        },
    },
};
</script>
